/* Creat effect on search input when focused */
export const InputEffect = () => {
  var placeholderPosition, actions;

  actions = {
    activate: el => {
      el.parentNode.parentNode.parentNode.classList.add("active");
    },
    deactivate: el => {
      if (el.value === "")
        el.parentNode.parentNode.parentNode.classList.remove("active");
    }
  };

  placeholderPosition = el => {
    if (el.value !== "") actions.activate(el);
    el.addEventListener("focus", function() {
      actions.activate(this);
    });
    el.addEventListener("blur", function() {
      actions.deactivate(this);
    });
  };

  document.querySelectorAll(".inputExpand").forEach(el => {
    placeholderPosition(el);
  });
};

// Retrive API
export const url = {
  BASE_URL:
    "https://api.flickr.com/services/rest/?method=flickr.photos.search&tag_mode=all&extras=tags&format=json&nojsoncallback=1&api_key=8578f982d7f44ae3cac7601143f54a09&per_page=30"
    //`https://api.flickr.com/services/rest/?method=flickr.photos.search&tags=${tag}&tag_mode=all&extras=tags&sort=interestingness-asc&format=json&nojsoncallback=1&api_key=8578f982d7f44ae3cac7601143f54a09&per_page=30`
};

/* Generate image url */
export const getImageUrl = (farm, server, id, secret) => {
  return `https://farm${farm}.staticflickr.com/${server}/${id}_${secret}.jpg`;
};



// WEBPACK FOOTER //
// ./src/utils.js